var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "payment-input",
      class: {
        "payment-input--error": _vm.error,
        "payment-input--readonly": _vm.readonly,
        "payment-input--disabled": _vm.disabled
      }
    },
    _vm._l(_vm.methodsFiltered, function(method) {
      return _c(
        "label",
        {
          key: method.code,
          staticClass: "payment-input__item",
          class: {
            "payment-input__item--active": _vm.value === method.code,
            "payment-input__item--disabled": method.disabled,
            "payment-input__item--readonly": _vm.readonly,
            "payment-input__item--error": _vm.error
          }
        },
        [
          _c("input", {
            staticClass: "payment-input__item-radio",
            attrs: {
              type: "radio",
              name: "payment-input",
              disabled:
                _vm.disabled ||
                method.disabled ||
                (_vm.readonly && _vm.value != method.code)
            },
            domProps: {
              value: method.code,
              checked: _vm.value === method.code
            },
            on: { change: _vm.onInput }
          }),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "payment-input__item-toggle" },
            [
              _c(
                _vm.iconComponent(method.icon || _vm.paymentIcon(method.code)),
                { tag: "component", staticClass: "payment-input__item-icon" }
              ),
              _vm._v(" "),
              _c("span", {
                staticClass: "payment-input__item-name",
                domProps: { innerHTML: _vm._s(method.name) }
              })
            ],
            1
          ),
          _vm._v(" "),
          method.description || method.instructions
            ? _c("span", { staticClass: "payment-input__item-content" }, [
                method.description
                  ? _c("span", {
                      staticClass: "payment-input__item-description",
                      domProps: { innerHTML: _vm._s(method.description) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                method.instructions
                  ? _c("span", {
                      staticClass: "payment-input__item-instructions",
                      domProps: { innerHTML: _vm._s(method.instructions) }
                    })
                  : _vm._e()
              ])
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }